export default __webpack_public_path__ + "static/5-4d7b92ec3f1e162e6107568f6ab79c4c.jpg";